<div class="container-fluid p-0 py-3">
    <div class="row g-3">
        <!-- Left: Week accordion -->
        <div class="col-lg-6">
            <div class="card shadow-sm">
                <div class="card-body">
                    <h5 class="card-title mb-3 fw-bold">Registro de consumo</h5>

                    <div class="accordion" id="weekAccordion">
                        <div *ngFor="let day of days"
                            class="accordion-item border-0 mb-1 rounded overflow-hidden">

                            <!-- ===== HEADER: Submitted day ===== -->
                            <h2 class="accordion-header border-0 mb-0" *ngIf="day.submitted">
                                <div class="accordion-custom-btn d-flex align-items-center border-bottom py-2"
                                    (click)="toggleDay(day)" style="cursor:pointer;">
                                    <!-- Green checkmark -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M21.4477 8.2C21.5 9.25014 21.5 10.4994 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C13.0719 2.5 14.0156 2.5 14.85 2.51908" stroke="#67B76F" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M8 11.5C8 11.5 9.5 11.5 11.5 15C11.5 15 16.5588 5.83333 21.5 4" stroke="#67B76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg> &nbsp;
                                    <span class="fw-semibold fs-6">{{ day.label }}</span>
                                    <!-- Botón validar: solo si no hay validación aún -->
                                    <div class="ms-auto me-2" (click)="$event.stopPropagation()"
                                        *ngIf="day.record?.is_valid === null || day.record?.is_valid === undefined">
                                        <button class="btn btn-outline-primary btn-sm px-3"
                                            *ngIf="canDo('Validacion de consumo')"
                                            (click)="openValidateModal(day)">
                                            Validar registro
                                        </button>
                                    </div>
                                    <!-- Badge estado validación -->
                                    <span class="ms-auto me-2 badge rounded-pill"
                                        *ngIf="day.record?.is_valid !== null && day.record?.is_valid !== undefined"
                                        [style.background]="day.record.is_valid ? '#e8f5e9' : '#e8f5e9'"
                                        [style.color]="day.record.is_valid ? '#2e7d32' : '#2e7d32'"
                                        style="font-size:0.78rem; padding: 6px 14px;">
                                        {{ day.record.is_valid ? 'Validado' : 'Validado' }}
                                    </span>
                                    <!-- Collapse arrow -->
                                    <svg class="flex-shrink-0 accordion-arrow" [class.rotated]="day.open"
                                        width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M6 15l6-6 6 6" stroke="#666" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </h2>

                            <!-- ===== HEADER: Pending / non-editable day ===== -->
                            <h2 class="accordion-header border-0 mb-0" *ngIf="!day.submitted">
                                <div class="accordion-custom-btn d-flex align-items-center border-bottom py-2"
                                    (click)="toggleDay(day)" style="cursor:pointer;">
                                    <span class="fw-semibold fs-6 me-2">{{ day.label }}</span>
                                    <svg class="ms-auto flex-shrink-0 accordion-arrow" [class.rotated]="day.open"
                                        width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M6 15l6-6 6 6" stroke="#666" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </h2>

                            <!-- ===== BODY ===== -->
                            <div class="accordion-collapse" [class.show]="day.open">
                                <div class="accordion-body p-0 pt-2" *ngIf="day.open">

                                    <!-- Saved record: plain text view -->
                                    <div *ngIf="day.submitted && day.record">
                                        <div class="card border-1 p-3 rounded">
                                            <h6 class="fw-bold mb-3">Evidencia de combustible</h6>

                                            <!-- ¿Quien realiza el registro? -->
                                            <div class="mb-3">
                                                <p class="field-label">¿Quién realiza el registro?</p>
                                                <p class="field-value">{{ day.record.recorded_by }}</p>
                                            </div>

                                            <!-- Fecha de evidencia -->
                                            <div class="mb-3">
                                                <p class="field-label">Fecha de evidencia</p>
                                                <p class="field-value">{{ formatDateDisplay(day.record.evidence_date) }}</p>
                                            </div>

                                            <!-- Fuel gauge (visual only) -->
                                            <div class="mb-3">
                                                <p class="field-label">Nivel de combustible</p>
                                                <div class="fuel-column align-items-center">
                                                    <div class="fuel-gauge">
                                                        <div class="fuel-gauge-container">
                                                            <div class="gauge">
                                                                <div class="needle"
                                                                    [style.transform]="'rotate(' + getNeedleAngle(+day.record.fuel_level) + 'deg)'">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <input type="range" min="0" max="100"
                                                            [value]="day.record.fuel_level"
                                                            style="width: 250px;" disabled />
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Kilometraje -->
                                            <div class="mb-3">
                                                <p class="field-label">Kilometraje actual</p>
                                                <p class="field-value">{{ day.record.mileage }} Km</p>
                                            </div>

                                            <!-- Saved photos -->
                                            <div *ngIf="day.record.images?.length">
                                                <div class="mb-2">
                                                    <p class="field-label">Fotos del tablero de la unidad</p>
                                                    <div class="d-flex flex-wrap gap-2">
                                                        <ng-container *ngFor="let img of day.record.images">
                                                            <img *ngIf="img.type === 'dashboard'"
                                                                [src]="getImageUrl(img.path)"
                                                                class="img-thumbnail"
                                                                style="height:80px;width:80px;object-fit:cover;">
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <div class="mb-2" *ngIf="hasTankImages(day.record.images)">
                                                    <p class="field-label">
                                                        Fotos del tanque derecho e izquierdo
                                                        <span class="text-muted fw-normal">(Opcional)</span>
                                                    </p>
                                                    <div class="d-flex flex-wrap gap-2">
                                                        <ng-container *ngFor="let img of day.record.images">
                                                            <img *ngIf="img.type === 'tank'"
                                                                [src]="getImageUrl(img.path)"
                                                                class="img-thumbnail"
                                                                style="height:80px;width:80px;object-fit:cover;">
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <!-- No record and not current day: informational message -->
                                    <div *ngIf="!isCurrentDay(day) && !day.submitted"
                                        class="p-3 text-center text-muted small border rounded">
                                        Aun no se puede realizar el registro del consumo de la unidad
                                    </div>

                                    <!-- Editable form: current day, not yet submitted -->
                                    <div *ngIf="isCurrentDay(day) && !day.submitted" class="evidence-form">
                                        <div class="card border-1 p-3 rounded">
                                            <h6 class="fw-bold mb-3">Evidencia de combustible</h6>

                                            <!-- ¿Quien realiza el registro? -->
                                            <div class="mb-3">
                                                <label class="form-label">¿Quién realiza el registro?</label>
                                                <input type="text" class="form-control" placeholder="Ingresar nombre"
                                                    [(ngModel)]="day.form.recorded_by">
                                            </div>

                                            <!-- Fecha de evidencia -->
                                            <div class="mb-3">
                                                <label class="form-label">Fecha de evidencia</label>
                                                <input type="date" class="form-control"
                                                    [(ngModel)]="day.form.evidence_date"
                                                    [max]="today" [min]="today">
                                            </div>

                                            <!-- Fuel gauge -->
                                            <div class="mb-3">
                                                <label class="form-label">Nivel de combustible</label>
                                                <div class="fuel-column align-items-center">
                                                    <div class="fuel-gauge">
                                                        <div class="fuel-gauge-container">
                                                            <div class="gauge">
                                                                <div class="needle"
                                                                    [style.transform]="'rotate(' + getNeedleAngle(day.form.fuel_level) + 'deg)'">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <input type="range" min="0" max="100" step="1"
                                                            class="color-primary"
                                                            [(ngModel)]="day.form.fuel_level"
                                                            style="width: 250px; color: #00A0E1;" />
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Kilometraje -->
                                            <div class="mb-3">
                                                <label class="form-label">Kilometraje actual</label>
                                                <div class="input-group">
                                                    <input type="number" class="form-control" placeholder="0.0"
                                                        min="0" step="0.1" [(ngModel)]="day.form.mileage">
                                                    <!-- <span class="input-group-text">Km</span> -->
                                                </div>
                                            </div>

                                            <!-- Dashboard photos (required) -->
                                            <div class="mb-3">
                                                <label class="form-label fw-semibold">Fotos del tablero de la unidad</label>
                                                <br>
                                                <div class="upload-actions" *ngIf="day.dashboardPreviews.length < 4">
                                                    <!-- Tomar foto: abre cámara en móvil -->
                                                    <label class="upload-btn" *ngIf="isMobile">
                                                        <input type="file" accept="image/*" capture="environment" hidden
                                                            (change)="onDashboardFileChange($event, day)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M2 9.5C2 8.67157 2.67157 8 3.5 8H4.5C5.06 8 5.5 7.56 5.67 7.05L6.16 5.55C6.38 4.9 7 4.5 7.68 4.5H16.32C17 4.5 17.62 4.9 17.84 5.55L18.33 7.05C18.5 7.56 18.94 8 19.5 8H20.5C21.33 8 22 8.67 22 9.5V18.5C22 19.33 21.33 20 20.5 20H3.5C2.67 20 2 19.33 2 18.5V9.5Z" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <circle cx="12" cy="13.5" r="3" stroke="#00A0E1" stroke-width="1.5"/>
                                                        </svg> Tomar foto
                                                    </label>
                                                    <!-- Subir foto: selector de archivos -->
                                                    <label class="upload-btn" *ngIf="!isMobile">
                                                        <input type="file" accept="image/*" multiple hidden
                                                            (change)="onDashboardFileChange($event, day)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M12 4.5L12 14.5M12 4.5C11.2998 4.5 9.99153 6.4943 9.5 7M12 4.5C12.7002 4.5 14.0085 6.4943 14.5 7" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg> Subir foto
                                                    </label>
                                                </div>
                                                <div class="upload-previews mt-2" *ngIf="day.dashboardPreviews.length">
                                                    <div class="d-flex flex-wrap gap-2">
                                                        <div *ngFor="let url of day.dashboardPreviews; let i = index"
                                                            class="preview-thumb position-relative">
                                                            <img [src]="url" class="img-thumbnail"
                                                                style="height:70px;width:70px;object-fit:cover;">
                                                            <button class="btn-remove-img"
                                                                (click)="removeDashboard(day, i)" type="button">×</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tank photos (optional) -->
                                            <div class="mb-1">
                                                <label class="form-label fw-semibold">
                                                    Fotos del tanque derecho e izquierdo
                                                    <span class="text-muted fw-normal">(Opcional)</span>
                                                </label>
                                                <br>
                                                <div class="upload-actions" *ngIf="day.tankPreviews.length < 4">
                                                    <label class="upload-btn" *ngIf="isMobile">
                                                        <input type="file" accept="image/*" capture="environment" hidden
                                                            (change)="onTankFileChange($event, day)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M2 9.5C2 8.67157 2.67157 8 3.5 8H4.5C5.06 8 5.5 7.56 5.67 7.05L6.16 5.55C6.38 4.9 7 4.5 7.68 4.5H16.32C17 4.5 17.62 4.9 17.84 5.55L18.33 7.05C18.5 7.56 18.94 8 19.5 8H20.5C21.33 8 22 8.67 22 9.5V18.5C22 19.33 21.33 20 20.5 20H3.5C2.67 20 2 19.33 2 18.5V9.5Z" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <circle cx="12" cy="13.5" r="3" stroke="#00A0E1" stroke-width="1.5"/>
                                                        </svg> Tomar foto
                                                    </label>
                                                    <label class="upload-btn" *ngIf="!isMobile">
                                                        <input type="file" accept="image/*" multiple hidden
                                                            (change)="onTankFileChange($event, day)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M12 4.5L12 14.5M12 4.5C11.2998 4.5 9.99153 6.4943 9.5 7M12 4.5C12.7002 4.5 14.0085 6.4943 14.5 7" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg> Subir foto
                                                    </label>
                                                </div>
                                                <div class="upload-previews mt-2" *ngIf="day.tankPreviews.length">
                                                    <div class="d-flex flex-wrap gap-2">
                                                        <div *ngFor="let url of day.tankPreviews; let i = index"
                                                            class="preview-thumb position-relative">
                                                            <img [src]="url" class="img-thumbnail"
                                                                style="height:70px;width:70px;object-fit:cover;">
                                                            <button class="btn-remove-img"
                                                                (click)="removeTank(day, i)" type="button">×</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right: Info panel -->
        <div class="col-lg-6">
            <div class="card shadow-sm">
                <div class="card-body">
                    <!-- Header -->
                    <div class="d-flex align-items-center mb-3">
                        <svg class="me-2" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="3" width="18" height="18" rx="3" stroke="#6c757d" stroke-width="1.5"/>
                            <path d="M7 8h10M7 12h7M7 16h5" stroke="#6c757d" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        <h6 class="fw-bold mb-0">Información del registro</h6>
                    </div>

                    <!-- Sin registros -->
                    <div *ngIf="allRecords.length === 0"
                        class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" class="mb-3">
                            <rect x="3" y="3" width="18" height="18" rx="3" stroke="#ced4da" stroke-width="1.5"/>
                            <path d="M7 8h10M7 12h7M7 16h5" stroke="#ced4da" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        <p class="small mb-0 text-center">Aun no hay registros<br>para esta semana</p>
                    </div>

                    <!-- Tabs -->
                    <ul class="nav nav-tabs mb-3" *ngIf="allRecords.length > 0" style="display:flex;">
                        <li class="nav-item" style="flex:1;">
                            <button class="nav-link w-100 text-center" [class.active]="historyTab === 'registros'"
                                (click)="historyTab = 'registros'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.616 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z" stroke="#00A0E1" stroke-width="1.5" stroke-linejoin="round"/>
                                    <path d="M13 4L20 11" stroke="#00A0E1" stroke-width="1.5" stroke-linejoin="round"/>
                                    <path d="M14 22L22 22" stroke="#00A0E1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                &nbsp;
                                Registros
                            </button>
                        </li>
                        <li class="nav-item" style="flex:1;">
                            <button class="nav-link w-100 text-center" [class.active]="historyTab === 'validaciones'"
                                (click)="historyTab = 'validaciones'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M21.4477 8.2C21.5 9.25014 21.5 10.4994 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C13.0719 2.5 14.0156 2.5 14.85 2.51908" stroke="#67B76F" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M8 11.5C8 11.5 9.5 11.5 11.5 15C11.5 15 16.5588 5.83333 21.5 4" stroke="#67B76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>&nbsp;
                                Validaciones
                            </button>
                        </li>
                    </ul>

                    <!-- Registros tab -->
                    <div *ngIf="historyTab === 'registros' && allRecords.length > 0">
                        <p class="text-primary small fw-semibold mb-3">
                            <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                            Historial de actualización
                        </p>

                        <div *ngIf="allRecords.length === 0"
                            class="border rounded p-3 text-center text-muted small">
                            Aun no hay historial de registro
                        </div>

                        <ng-container *ngFor="let rec of allRecords; let last = last">
                            <div class="py-3" [class.border-bottom]="!last">
                                <div class="row g-0 mb-2">
                                    <div class="col-6 pe-2">
                                        <p class="text-muted mb-2" style="font-size:0.78rem;">Última actualización:</p>
                                        <p class="mb-0" style="font-size:0.8rem; color:#555;">
                                            <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                                            Fecha y hora:<br>
                                            <span class="ms-2" style="color:#333;">{{ formatDateTime(rec.updated_at) }}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 ps-2">
                                        <p class="text-muted mb-2" style="font-size:0.78rem;">Realizado por:</p>
                                        <p class="mb-0" style="font-size:0.8rem; color:#555;">
                                            <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                                            {{ rec.recorded_by }}
                                        </p>
                                    </div>
                                </div>
                                <p class="text-muted mb-1 mt-2" style="font-size:0.78rem;">Descripción:</p>
                                <p class="mb-0" style="font-size:0.8rem; color:#555;">
                                    <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                                    Registro de consumo - {{ ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'][rec.day_of_week - 1] }}
                                </p>
                            </div>
                        </ng-container>
                    </div>

                    <!-- Validaciones tab -->
                    <div *ngIf="historyTab === 'validaciones' && allRecords.length > 0">
                        <p class="text-primary small fw-semibold mb-3">
                            <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                            Historial de validación
                        </p>

                        <div *ngIf="validatedRecords.length === 0"
                            class="border rounded p-3 text-center text-muted small">
                            No hay validaciones disponibles
                        </div>

                        <ng-container *ngFor="let rec of validatedRecords; let last = last">
                            <div class="py-3" [class.border-bottom]="!last">

                                <div class="row g-0 mb-2">
                                    <div class="col-6 pe-2">
                                        <p class="text-muted mb-2" style="font-size:0.78rem;">Última actualización:</p>
                                        <p class="mb-0" style="font-size:0.8rem; color:#555;">
                                            <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                                            Fecha y hora:<br>
                                            <span class="ms-2" style="color:#333;">{{ formatDateTime(rec.validated_at) }}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 ps-2">
                                        <p class="text-muted mb-2" style="font-size:0.78rem;">Realizado por:</p>
                                        <p class="mb-0" style="font-size:0.8rem; color:#555;">
                                            <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                                            {{ rec.validated_by }}
                                        </p>
                                    </div>
                                </div>

                                <p class="text-muted mb-1 mt-2" style="font-size:0.78rem;">Descripción:</p>
                                <p class="mb-0" style="font-size:0.8rem; color:#555;">
                                    <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                                    Validación de consumo - {{ ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'][rec.day_of_week - 1] }}
                                </p>
                                <p *ngIf="rec.validation_notes" class="mb-0 mt-1" style="font-size:0.8rem; color:#c62828;">
                                    <span style="font-size:0.45rem;vertical-align:middle;" class="me-1">●</span>
                                    {{ rec.validation_notes }}
                                </p>

                            </div>
                        </ng-container>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Bottom buttons -->
    <div class="d-flex justify-content-center gap-3 mt-4">
        <button class="btn btn-outline-secondary py-2 fw-semibold" style="min-width: 180px;"
            (click)="goBack()">
            Cancelar
        </button>
        <button class="btn btn-primary py-2 fw-semibold" style="min-width: 180px;"
            (click)="submit()"
            [disabled]="!currentDay || currentDay.submitted">
            Registrar consumo
        </button>
    </div>

</div>

<!-- ===== Validation Modal ===== -->
<div class="validate-overlay" *ngIf="validateModal.visible" (click)="closeValidateModal()">
    <div class="validate-dialog" (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="fw-bold mb-0">Validar registro</h5>
            <a role="button" (click)="closeValidateModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19.0005 5L5.00049 19M5.00049 5L19.0005 19" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </a>
        </div>

        <!-- Question -->
        <p class="mb-3" style="font-size:0.9rem; color:#212529;">
            ¿Todos los datos ingresados en el registro del dia se encuentran correctamente evidenciados?
        </p>

        <!-- Si / No checkboxes -->
        <div class="d-flex gap-4 mb-4 justify-content-center">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="valSi"
                    [checked]="validateModal.correctlyEvidenced === true"
                    (change)="setValidationAnswer(true)">
                <label class="form-check-label" for="valSi">Si</label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="valNo"
                    [checked]="validateModal.correctlyEvidenced === false"
                    (change)="setValidationAnswer(false)">
                <label class="form-check-label" for="valNo">No</label>
            </div>
        </div>

        <!-- Inconsistency textarea (only when No) -->
        <div *ngIf="validateModal.correctlyEvidenced === false" class="mb-4">
            <p class="mb-2" style="font-size:0.9rem; color:#212529;">
                ¿Que inconsistencia presenta el registro de consumo? Por favor ingrese la descripción
            </p>
            <textarea class="form-control" rows="3" maxlength="500"
                [(ngModel)]="validateModal.inconsistency"
                placeholder=""></textarea>
            <div class="text-end text-muted small mt-1">
                {{ validateModal.inconsistency.length }}/500
            </div>
        </div>

        <!-- Who validates -->
        <div class="mb-4">
            <p class="mb-2" style="font-size:0.9rem; color:#212529;">¿Quien realiza la validación?</p>
            <input type="text" class="form-control" placeholder="Ingresar nombre" disabled=""
                [(ngModel)]="validateModal.validatedBy">
        </div>

        <!-- Buttons -->
        <div class="d-flex gap-3">
            <button class="btn btn-outline-secondary flex-fill" (click)="closeValidateModal()"
                [disabled]="validateModal.submitting">
                Cancelar
            </button>
            <button class="btn btn-primary flex-fill" (click)="confirmValidation()"
                [disabled]="validateModal.submitting">
                {{ validateModal.submitting ? 'Validando...' : 'Validar' }}
            </button>
        </div>

    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
